import axios from 'axios'
import { api } from '@/services/config'
import moment from 'moment'
import store from '@/store'
import { mixin } from '@/mixins/helper'

const level1 = {
  namespaced: true,
  state: () => ({
    isLoading: false,
    dataLevel1: null,

    statusCategory: 'Semua',
    currentPage: 1,
    totalData: 0,

    activeTab: 'profil',
    activeBottom: 'profil',

    vendorId: null,
    aribaId: null,

    profile: null,

    information: null,

    md_landingpage: [],
    md_step_1: [],
    md_step_2: [],
    md_step_3: [],
    md_step_4: [],
    md_step_5: [],
    md_step_6: [],
    md_step_7: [],

    choosedKbli: [],

    detailPo: null,
    chartPo: null,
    totalPo: null,
    poPage: 1,
    poPerPage: 10,
    poTotalItems: 0,
    poTotalPages: 0,
    customDetailPoStart: moment(Date.now())
      .subtract(36, 'months')
      .format('YYYY-MM-DD'),
    customDetailPoEnd: moment(Date.now()).format('YYYY-MM-DD'),

    kinerjaPo: null,
    chartKinerjaPo: null,
    totalKinerjaPo: null,
    kinerjaPoPage: 1,
    kinerjaPoPerPage: 10,
    kinerjaPoTotalItems: 0,
    kinerjaPoTotalPages: 0,
    customKinerjaPoStart: moment(Date.now())
      .subtract(36, 'months')
      .format('YYYY-MM-DD'),
    customKinerjaPoEnd: moment(Date.now()).format('YYYY-MM-DD'),

    detailPoOrder: 'asc',
    totalEventOrder: 'asc',
    kinerjaKontrakOrder: 'asc',
    kinerjaPoOrder: 'asc',

    legalDoc: null,

    totalEventDetail: null,
    totalEventChart: null,
    totalEventPage: 1,
    totalEventPerPage: 10,
    totalEventTotalItems: 0,
    totalEventTotalPages: 0,
    customEventStart: moment()
      .subtract(36, 'months')
      .format('YYYY-MM-DD'),
    customEventEnd: moment(Date.now()).format('YYYY-MM-DD'),

    sioData: null,

    k3lData: null,
    kplhData: null,

    spmDetail: null,
    spmChart: null,
    spmPage: 1,
    spmPerPage: 10,
    spmTotalItems: 0,
    spmTotalPages: 0,
    customSpmStart: moment()
      .subtract(36, 'months')
      .format('YYYY-MM-DD'),
    customSpmEnd: moment(Date.now()).format('YYYY-MM-DD'),

    csiData: null,

    query: {
      vendorName: '',
      status: '',
      negara: '',
      prov: '',
      kota: '',
      kec: '',
      kel: '',
      tambang: '',
      sio: '',
      k3l: '',
      kplh: '',
      poStart: '',
      poEnd: '',
      eventStart: '',
      eventEnd: '',
      spmStart: '',
      spmEnd: '',
      sioStart: '',
      sioEnd: '',
      k3lStart: '',
      k3lEnd: '',
      kplhStart: '',
      kplhEnd: '',
      gradeStart: '',
      gradeEnd: '',
      csiStart: '',
      csiEnd: '',
      k3lScore: '',
      kplhScore: '',
      kbliSub: '',
      kbliParent: '',
      iujp: '',
      ijuptl: '',
      sbujk: '',
      inubbm: '',
      siupal: '',
    },

    kbliId: null,
    queryOrder: '',
    page: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    nextPageLink: null,
    previousPageLink: null,
  }),
  mutations: {
    SET_LOADING(state, data) {
      state.isLoading = data
    },
    SET_QUERY_PARAMS(state, name, value) {
      state.query[`${name}`] = value && value !== '' ? value : ''
    },
    async SET_DATA_LEVEL1(state, params) {
      state.query =
        params && params.query && params.query !== ''
          ? { ...state.query, ...params.query }
          : { ...state.query }

      let allQuery = ''
      let arrQuery = Object.entries(state.query)
      for (let i in arrQuery) {
        if (arrQuery[i][1] != '') {
          allQuery += arrQuery[i][1]
        }
      }

      if (params && !params.notReset) {
        state.page = 1
      }

      const url = `${api}/api/v1/vendor-level-1?page=${state.page}&limit=${state.perPage}${allQuery}${state.queryOrder}`
      try {
        state.isLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.dataLevel1 = data.data
        state.page = data.pagination.page
        state.perPage = data.pagination.perPage
        state.totalItems = data.pagination.totalItems
        state.totalPages = data.pagination.totalPages

        state.isLoading = false
      } catch (error) {
        state.dataLevel1 = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async LEVEL1_ORDER_BY(state, order) {
      state.queryOrder = order ? order : ''
      const url = `${api}/api/v1/vendor-level-1?page=${state.page}&limit=${
        state.perPage
      }${
        state.kbliId ? `&kbli_parent=${state.kbliId}` : ''
      }${`${state.query.vendorName}${state.query.status}${state.query.negara}${state.query.prov}${state.query.kota}${state.query.kec}${state.query.kel}${state.query.tambang}${state.query.sio}${state.query.k3l}${state.query.kplh}${state.query.gradeStart}${state.query.gradeEnd}${state.query.csiStart}${state.query.csiEnd}${state.query.k3lScore}${state.query.kplhScore}${state.query.kbliSub}${state.query.poStart}${state.query.poEnd}${state.query.eventStart}${state.query.eventEnd}${state.query.spmStart}${state.query.spmEnd}${state.query.sioStart}${state.query.sioEnd}${state.query.k3lStart}${state.query.k3lEnd}${state.query.kplhStart}${state.query.kplhEnd}`}${
        state.queryOrder
      }`

      try {
        state.isLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })
        state.dataLevel1 = data.data
        state.page = data.pagination.page
        state.perPage = data.pagination.perPage
        state.totalItems = data.pagination.totalItems
        state.totalPages = data.pagination.totalPages
        state.isLoading = false
      } catch (error) {
        state.dataLevel1 = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    SET_CURRENT_TAB(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
    },

    async GET_PROFILE_DATA(state, payload) {
      state.vendorId = payload && payload.id
      state.activeTab = 'profil'
      state.activeBottom = 'profil'
      let url = `${api}/api/v1/d-vendor-profile?id=${state.vendorId}${state.query.poStart}${state.query.poEnd}${state.query.eventStart}${state.query.eventEnd}${state.query.spmStart}${state.query.spmEnd}${state.query.sioStart}${state.query.sioEnd}${state.query.k3lStart}${state.query.k3lEnd}${state.query.kplhStart}${state.query.kplhEnd}`

      if (payload && payload.tab) {
        state.activeTab = payload.tab.name
        state.activeBottom = payload.tab.name
        url = `${api}/api/v1/d-vendor-profile?request_id=${payload.tab.request_id}`
      }

      try {
        state.isLoading = true
        const { data } = await axios({
          methods: 'GET',
          url,
        })
        state.vendorId = data.data.id
        state.profile = data.data
        state.aribaId = data.data && data.data.ariba_code

        state.isLoading = false
        return state.profile
      } catch (error) {
        state.isLoading = false
        state.profile = null
        state.aribaId = null
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async INFO_CALLBACK(state, payload) {
      state.activeTab = payload.tab
      state.activeBottom = payload.tab
      let url = `${api}/api/v1/d-vendor-informasi?id=${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
          timeout: 300000,
        })

        state.information = data.data
        let infoKbli =
          data.data &&
          data.data.kbli &&
          data.data.kbli.sort((a, b) => {
            if (a.kbli_sub_id < b.kbli_sub_id) {
              return -1
            }
            if (a.kbli_sub_id > b.kbli_sub_id) {
              return 1
            }
            return 0
          })
        state.information.kbli = infoKbli

        let storeChoosedKbli = []
        if (data.data) {
          for (let i in data.data.kbli) {
            storeChoosedKbli.push({
              id_kbli_vendor: data.data.kbli[i].id,
              ...data.data.kbli[i].kbli_sub,
            })
          }
          state.choosedKbli = storeChoosedKbli
        }

        await payload.updateInfoSuccess

        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_INFO_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      let url = `${api}/api/v1/d-vendor-informasi?id=${state.vendorId}`

      if (typeof tab == 'object') {
        state.activeTab = tab.name
        state.activeBottom = tab.name
        url = `${api}/api/v1/d-vendor-informasi?request_id=${tab.request_id}`
      }

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
          timeout: 300000,
        })

        state.information = data.data
        let infoKbli =
          data.data &&
          data.data.kbli &&
          data.data.kbli.sort((a, b) => {
            if (a.kbli_sub_id < b.kbli_sub_id) {
              return -1
            }
            if (a.kbli_sub_id > b.kbli_sub_id) {
              return 1
            }
            return 0
          })
        state.information.kbli = infoKbli

        let storeChoosedKbli = []
        if (data.data) {
          for (let i in data.data.kbli) {
            storeChoosedKbli.push({
              id_kbli_vendor: data.data.kbli[i].id,
              ...data.data.kbli[i].kbli_sub,
            })
          }
          state.choosedKbli = storeChoosedKbli
        }

        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async GET_DETAIL_PO(state, tab) {
      const urlDetail = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}&ariba_code=${state.aribaId}&order=${state.detailPoOrder}`
      const urlChart = `${api}/api/v1/d-vendor-po/chart?start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}`
      const urlTotal = `${api}/api/v1/d-vendor-po/total?start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        const { data: total } = await axios({
          method: 'GET',
          url: urlTotal,
        })

        state.detailPo = data.data
        state.poPage = data.pagination.page
        state.poPerPage = data.pagination.perPage
        state.poTotalItems = data.pagination.totalItems
        state.poTotalPages = data.pagination.totalPages
        state.chartPo = chart.data

        state.totalPo = total.data[0]

        setTimeout(() => {
          state.activeTab = tab
          state.activeBottom = tab
          state.isLoading = false
        }, 1000)
      } catch (error) {
        state.isLoading = false

        state.detailPo = null

        state.chartPo = []
        state.totalPo = null

        state.activeTab = tab
        state.activeBottom = tab
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async CUSTOM_DETAIL_PO(state, query) {
      state.customDetailPoStart = query.poStart
      state.customDetailPoEnd = query.poEnd
      state.activeTab = 'loading'

      const urlDetail = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}&ariba_code=${state.aribaId}&order=${state.detailPoOrder}`
      const urlChart = `${api}/api/v1/d-vendor-po/chart?start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}`
      const urlTotal = `${api}/api/v1/d-vendor-po/total?start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}`
      try {
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        const { data: total } = await axios({
          method: 'GET',
          url: urlTotal,
        })

        state.detailPo = data.data
        state.poPage = data.pagination.page
        state.poPerPage = data.pagination.perPage
        state.poTotalItems = data.pagination.totalItems
        state.poTotalPages = data.pagination.totalPages
        state.chartPo = chart.data
        state.totalPo = total.data[0]

        await setTimeout(function() {
          state.activeTab = 'detailpo'
        }, 1000)
      } catch (error) {
        state.detailPo = null
        state.chartPo = []
        state.totalPo = null

        state.poPage = 1
        state.poPerPage = 10
        state.poTotalItems = 0
        state.poTotalPages = 0

        state.activeTab = 'detailpo'
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async ORDER_DETAIL_PO(state) {
      if (state.detailPoOrder == 'asc') {
        state.detailPoOrder = 'desc'
      } else {
        state.detailPoOrder = 'asc'
      }

      const url = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}&order=${state.detailPoOrder}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.detailPo = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_DETAIL_PO_PAGE(state) {
      const urlDetail = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customDetailPoStart}&end_date=${state.customDetailPoEnd}&vendor_id=${state.vendorId}&ariba_code=${state.aribaId}&order=${state.detailPoOrder}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        state.detailPo = data.data
        ;(state.poPage = data.pagination.page),
          (state.poPerPage = data.pagination.perPage),
          (state.poTotalItems = data.pagination.totalItems),
          (state.poTotalPages = data.pagination.totalPages),
          (state.isLoading = false)
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async GET_KINERJA_PO(state, tab) {
      const urlDetail = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}&ariba_code=${state.aribaId}&order=${state.kinerjaPoOrder}`
      const urlChart = `${api}/api/v1/d-vendor-po/chart?start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}`
      const urlTotal = `${api}/api/v1/d-vendor-po/total?start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        const { data: total } = await axios({
          method: 'GET',
          url: urlTotal,
        })

        state.detailPo = data.data
        state.poPage = data.pagination.page
        state.poPerPage = data.pagination.perPage
        state.poTotalItems = data.pagination.totalItems
        state.poTotalPages = data.pagination.totalPages
        state.chartPo = chart.data

        state.totalPo = total.data[0]

        setTimeout(() => {
          state.activeTab = tab
          state.activeBottom = tab
          state.isLoading = false
        }, 1000)
      } catch (error) {
        state.isLoading = false

        state.detailPo = null

        state.chartPo = []
        state.totalPo = null

        state.activeTab = tab
        state.activeBottom = tab
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async CUSTOM_KINERJA_PO(state, query) {
      state.customKinerjaPoStart = query.poStart
      state.customKinerjaPoEnd = query.poEnd
      state.activeTab = 'loading'

      const urlDetail = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}&ariba_code=${state.aribaId}&order=${state.kinerjaPoOrder}`
      const urlChart = `${api}/api/v1/d-vendor-po/chart?start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}`
      const urlTotal = `${api}/api/v1/d-vendor-po/total?start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}`
      try {
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        const { data: total } = await axios({
          method: 'GET',
          url: urlTotal,
        })

        state.detailPo = data.data
        state.poPage = data.pagination.page
        state.poPerPage = data.pagination.perPage
        state.poTotalItems = data.pagination.totalItems
        state.poTotalPages = data.pagination.totalPages
        state.chartPo = chart.data
        state.totalPo = total.data[0]

        await setTimeout(function() {
          state.activeTab = 'kinerjapo'
        }, 1000)
      } catch (error) {
        state.detailPo = null
        state.chartPo = []
        state.totalPo = null

        state.poPage = 1
        state.poPerPage = 10
        state.poTotalItems = 0
        state.poTotalPages = 0

        state.activeTab = 'kinerjapo'
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async ORDER_KINERJA_PO(state) {
      if (state.kinerjaPoOrder == 'asc') {
        state.kinerjaPoOrder = 'desc'
      } else {
        state.kinerjaPoOrder = 'asc'
      }

      const url = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}&order=${state.kinerjaPoOrder}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.detailPo = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_KINERJA_PO_PAGE(state) {
      const urlDetail = `${api}/api/v1/d-vendor-po/detail?page=${state.poPage}&limit=${state.poPerPage}&start_date=${state.customKinerjaPoStart}&end_date=${state.customKinerjaPoEnd}&vendor_id=${state.vendorId}&ariba_code=${state.aribaId}&order=${state.kinerjaPoOrder}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        state.detailPo = data.data
        ;(state.poPage = data.pagination.page),
          (state.poPerPage = data.pagination.perPage),
          (state.poTotalItems = data.pagination.totalItems),
          (state.poTotalPages = data.pagination.totalPages),
          (state.isLoading = false)
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async LEGAL_DOC_CALLBACK(state, payload) {
      let url = `${api}/api/v1/d-vendor-legal-document?page=1&limit=50&vendor_id=${state.vendorId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.data) {
          payload.onSuccess(data.data)
        }
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async GET_LEGAL_DOC(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      let url = `${api}/api/v1/d-vendor-legal-document?page=1&limit=50&vendor_id=${state.vendorId}`

      if (typeof tab == 'object') {
        state.activeTab = tab.name
        state.activeBottom = tab.name
        url = `${api}/api/v1/d-vendor-legal-document?page=1&limit=50&request_id=${tab.request_id}`
      }

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        if (data && data.data.length > 0) {
          state.legalDoc = data.data
        } else {
          state.legalDoc = []
        }

        state.legalDoc = data.data
        state.isLoading = false
      } catch (error) {
        state.legalDoc = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async GET_TOTAL_EVENT(state, tab) {
      const urlDetail = `${api}/api/v1/d-vendor-event/detail?page=${state.totalEventPage}&limit=${state.totalEventPerPage}&start_date=${state.customEventStart}&end_date=${state.customEventEnd}&vendor_id_ariba=${state.aribaId}&order=${state.totalEventOrder}`
      const urlChart = `${api}/api/v1/d-vendor-event/chart?start_date=2018-01-01&end_date=2021-12-31&vendor_id_ariba=${state.aribaId}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })
        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        state.totalEventDetail = data.data
        state.totalEventPage = data.pagination.page
        state.totalEventPerPage = data.pagination.perPage
        state.totalEventTotalItems = data.pagination.totalItems
        state.totalEventTotalPages = data.pagination.totalPages

        state.totalEventChart = chart.data

        setTimeout(() => {
          state.activeTab = tab
          state.activeBottom = tab
          state.isLoading = false
        }, 1000)
      } catch (error) {
        state.totalEventDetail = null
        state.totalEventPage = 1
        state.totalEventPerPage = 10
        state.totalEventTotalItems = 0
        state.totalEventTotalPages = 0

        state.totalEventChart = []

        state.activeTab = tab
        state.activeBottom = tab
        state.isLoading = false
      }
    },
    async CUSTOM_TOTAL_EVENT(state, query) {
      state.activeTab = 'loading'
      state.customEventStart = query.eventStart
      state.customEventEnd = query.eventEnd

      const urlDetail = `${api}/api/v1/d-vendor-event/detail?page=${state.totalEventPage}&limit=${state.totalEventPerPage}&start_date=${state.customEventStart}&end_date=${state.customEventEnd}&vendor_id_ariba=${state.aribaId}&order=${state.totalEventOrder}`
      const urlChart = `${api}/api/v1/d-vendor-event/chart?start_date=${state.customEventStart}&end_date=${state.customEventEnd}&vendor_id_ariba=${state.aribaId}`
      try {
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })
        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        state.totalEventDetail = data.data
        state.totalEventPage = data.pagination.page
        state.totalEventPerPage = data.pagination.perPage
        state.totalEventTotalItems = data.pagination.totalItems
        state.totalEventTotalPages = data.pagination.totalPages
        state.totalEventChart = chart.data
        await setTimeout(function() {
          state.activeTab = 'totalevent'
        }, 1000)
      } catch (error) {
        state.totalEventDetail = null
        state.totalEventPage = 1
        state.totalEventPerPage = 10
        state.totalEventTotalItems = 0
        state.totalEventTotalPages = 0

        state.totalEventChart = []

        state.activeTab = 'totalevent'
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async ORDER_TOTAL_EVENT(state) {
      if (state.totalEventOrder == 'asc') {
        state.totalEventOrder = 'desc'
      } else {
        state.totalEventOrder = 'asc'
      }

      const url = `${api}/api/v1/d-vendor-event/detail?page=${state.totalEventPage}&limit=${state.totalEventPerPage}&start_date=${state.customEventStart}&end_date=${state.customEventEnd}&vendor_id_ariba=${state.aribaId}&order=${state.totalEventOrder}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.totalEventDetail = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_TOTAL_EVENT_PAGE(state) {
      const urlDetail = `${api}/api/v1/d-vendor-event/detail?page=${state.totalEventPage}&limit=${state.totalEventPerPage}&start_date=${state.customEventStart}&end_date=${state.customEventEnd}&vendor_id_ariba=${state.aribaId}&order=${state.totalEventOrder}`
      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        state.totalEventDetail = data.data
        state.totalEventPage = data.pagination.page
        state.totalEventPerPage = data.pagination.perPage
        state.totalEventTotalItems = data.pagination.totalItems
        state.totalEventTotalPages = data.pagination.totalPages
        state.isLoading = false
      } catch (error) {
        state.totalEventDetail = null
        state.totalEventPage = 1
        state.totalEventPerPage = 10
        state.totalEventTotalItems = 0
        state.totalEventTotalPages = 0

        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async GET_SIO_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      state.sioData = null

      const url = `${api}/api/v1/d-vendor-sio?page=1&limit=1000&vendor_id=${state.vendorId}&order_by=start_date&order_short=asc`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.sioData = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_K3L_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      state.k3lData = null

      const url = `${api}/api/v1/d-vendor-k3l?page=1&limit=100&vendor_id=${state.vendorId}&order_by=tanggal_efektif&order_short=asc`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.k3lData = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async SHORT_K3L_DATA(state, payload) {
      state.k3lData = null

      const url = `${api}/api/v1/d-vendor-k3l?page=1&limit=10&vendor_id=${state.vendorId}&order_by=${payload.column}&order_short=${payload.order_name}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.k3lData = data.data
        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_KPLH_DATA(state, tab) {
      state.activeTab = tab
      state.activeBottom = tab
      const url = `${api}/api/v1/d-vendor-kplh?page=1&limit=100&vendor_id=${state.vendorId}&order_by=tanggal_efektif&order_short=asc`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.kplhData = data.data
        state.isLoading = false
      } catch (error) {
        state.kplhData = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async SHORT_KPLH_DATA(state, payload) {
      const url = `${api}/api/v1/d-vendor-kplh?page=1&limit=100&vendor_id=${state.vendorId}&order_by=${payload.column}&order_short=${payload.order_name}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url,
        })

        state.kplhData = data.data
        state.isLoading = false
      } catch (error) {
        state.kplhData = null
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    async GET_KINERJA_KONTRAK(state, tab) {
      const urlDetail = `${api}/api/v1/d-vendor-kinerja-kontrak/detail?page=${state.spmPage}&limit=${state.spmPerPage}&start_date=${state.customSpmStart}&end_date=${state.customSpmEnd}&vendor_id_ariba=${state.aribaId}&order=${state.kinerjaKontrakOrder}`
      const urlChart = `${api}/api/v1/d-vendor-kinerja-kontrak/chart?start_date=${state.customSpmStart}&end_date=${state.customSpmEnd}&vendor_id_ariba=${state.aribaId}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })
        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        state.spmDetail = data.data
        state.spmPage = data.pagination.page
        state.spmPerPage = data.pagination.perPage
        state.spmTotalItems = data.pagination.totalItems
        state.spmTotalPages = data.pagination.totalPages

        state.spmChart = chart.data

        setTimeout(() => {
          state.activeTab = tab
          state.activeBottom = tab
          state.isLoading = false
        }, 1000)
      } catch (error) {
        state.spmDetail = null
        state.spmPage = 1
        state.spmPerPage = 10
        state.spmTotalItems = 0
        state.spmTotalPages = 0
        state.spmChart = []

        state.activeTab = tab
        state.activeBottom = tab
        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async CUSTOM_KINERJA_KONTRAK(state, query) {
      state.customSpmStart = query.startDate
      state.customSpmEnd = query.endDate
      state.activeTab = 'loading'

      const urlDetail = `${api}/api/v1/d-vendor-kinerja-kontrak/detail?page=${state.spmPage}&limit=${state.spmPerPage}&start_date=${state.customSpmStart}&end_date=${state.customSpmEnd}&vendor_id_ariba=${state.aribaId}&order=${state.kinerjaKontrakOrder}`
      const urlChart = `${api}/api/v1/d-vendor-kinerja-kontrak/chart?start_date=${state.customSpmStart}&end_date=${state.customSpmEnd}&vendor_id_ariba=${state.aribaId}`

      try {
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })
        const { data: chart } = await axios({
          method: 'GET',
          url: urlChart,
        })

        state.spmDetail = data.data
        state.spmPage = data.pagination.page
        state.spmPerPage = data.pagination.perPage
        state.spmTotalItems = data.pagination.totalItems
        state.spmTotalPages = data.pagination.totalPages
        state.spmChart = chart.data
        await setTimeout(function() {
          state.activeTab = 'kinerjakontrak'
        }, 1000)
      } catch (error) {
        state.spmDetail = null
        state.spmPage = 1
        state.spmPerPage = 10
        state.spmTotalItems = 0
        state.spmTotalPages = 0

        state.spmChart = []

        state.activeTab = 'kinerjakontrak'
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async ORDER_KINERJA_KONTRAK(state) {
      if (state.kinerjaKontrakOrder == 'asc') {
        state.kinerjaKontrakOrder = 'desc'
      } else {
        state.kinerjaKontrakOrder = 'asc'
      }

      const url = `${api}/api/v1/d-vendor-kinerja-kontrak/detail?page=${state.spmPage}&limit=${state.spmPerPage}&start_date=${state.customSpmStart}&end_date=${state.customSpmEnd}&vendor_id_ariba=${state.aribaId}&order=${state.kinerjaKontrakOrder}`

      try {
        state.isLoading = true
        const { data } = await axios({
          method: 'GET',
          url: url,
        })

        state.spmDetail = data.data

        state.isLoading = false
      } catch (error) {
        state.isLoading = false
        state.spmDetail = null
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async GET_KINERJA_KONTRAK_PAGE(state, tab) {
      const urlDetail = `${api}/api/v1/d-vendor-kinerja-kontrak/detail?page=${state.spmPage}&limit=${state.spmPerPage}&start_date=${state.customSpmStart}&end_date=${state.customSpmEnd}&vendor_id_ariba=${state.aribaId}&order=${state.kinerjaKontrakOrder}`
      state.isLoading = true

      try {
        const { data } = await axios({
          method: 'GET',
          url: urlDetail,
        })

        state.spmDetail = data.data
        state.spmPage = data.pagination.page
        state.spmPerPage = data.pagination.perPage
        state.spmTotalItems = data.pagination.totalItems
        state.spmTotalPages = data.pagination.totalPages

        state.isLoading = false
      } catch (error) {
        state.spmDetail = null
        state.spmPage = 1
        state.spmPerPage = 10
        state.spmTotalItems = 0
        state.spmTotalPages = 0

        state.isLoading = false
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
      }
    },

    SET_LEVEL1_PAGE(state, page) {
      state.page = page
    },
    SET_LEVEL1_PERPAGES(state, page) {
      state.perPage = page
    },
    SET_TOTAL_EVENT_PAGE(state, page) {
      state.totalEventPage = page
    },
    SET_TOTAL_EVENT_PERPAGES(state, page) {
      state.totalEventPerPage = page
    },
    SET_PO_PAGE(state, page) {
      state.poPage = page
    },
    SET_PO_PERPAGES(state, page) {
      state.poPerPage = page
    },
    SET_KINERJA_KONTRAK_PAGE(state, page) {
      state.spmPage = page
    },
    SET_KINERJA_KONTRAK_PERPAGES(state, page) {
      state.spmPerPage = page
    },
    RESET_QUERY(state) {
      state.query = {
        vendorName: '',
        status: '',
        negara: '',
        prov: '',
        kota: '',
        kec: '',
        kel: '',
        tambang: '',
        sio: '',
        k3l: '',
        kplh: '',
        poStart: '',
        poEnd: '',
        eventStart: '',
        eventEnd: '',
        spmStart: '',
        spmEnd: '',
        sioStart: '',
        sioEnd: '',
        k3lStart: '',
        k3lEnd: '',
        kplhStart: '',
        kplhEnd: '',
        gradeStart: '',
        gradeEnd: '',
        csiStart: '',
        csiEnd: '',
        k3lScore: '',
        kplhScore: '',
        kbliSub: '',
        kbliParent: '',
      }
    },
    UPDATE_DATA(state, data) {
      state[data.name] = [...state[data.name], ...data.value]
    },
    SET_STATUS_CATEGORY(state, status) {
      if (status) {
        state.statusCategory = status
      } else {
        state.statusCategory = 'Semua'
      }
    },
    SET_CUSTOM_DATE(state, date) {
      state[date.name] = date.value
    },
  },
  actions: {
    async setLevel1Page({ commit }, page) {
      await commit('SET_LEVEL1_PAGE', page)
    },
    async setLevel1PerPage({ commit }, page) {
      await commit('SET_LEVEL1_PERPAGES', page)
      await commit('SET_DATA_LEVEL1')
    },

    async setCurrentTab({ state, commit, dispatch }, tab) {
      let name = null
      let payload = {
        id: state.vendorId,
      }

      if (typeof tab == 'object') {
        name = tab.name
        payload = {
          id: null,
          tab,
        }
      } else {
        name = tab
      }
      switch (name) {
        case 'profil':
          commit('GET_PROFILE_DATA', payload)
          break
        case 'informasi':
          await commit('GET_INFO_DATA', tab)
          await dispatch('getAdditionalInfo')
          break
        case 'detailpo':
          commit('GET_DETAIL_PO', tab)
          break
        case 'legaldoc':
          commit('GET_LEGAL_DOC', tab)
          break
        case 'totalevent':
          commit('GET_TOTAL_EVENT', tab)
          break
        case 'sio':
          commit('GET_SIO_DATA', tab)
          break
        case 'k3l':
          commit('GET_K3L_DATA', tab)
          break
        case 'kplh':
          commit('GET_KPLH_DATA', tab)
          break
        case 'kinerjakontrak':
          commit('GET_KINERJA_KONTRAK', tab)
          break
        case 'kinerjapo':
          commit('GET_KINERJA_PO', tab)
          break
        default:
          break
      }
    },
    async setPoPage({ commit }, page) {
      await commit('SET_PO_PAGE', page)
      await commit('GET_DETAIL_PO_PAGE')
    },
    async setPoPerPage({ commit }, page) {
      await commit('SET_PO_PERPAGES', page)
      await commit('GET_DETAIL_PO_PAGE')
    },
    async setKinerjaPoPage({ commit }, page) {
      await commit('SET_PO_PAGE', page)
      await commit('GET_DETAIL_PO_PAGE')
    },
    async setKinerjaPoPerPage({ commit }, page) {
      await commit('SET_PO_PERPAGES', page)
      await commit('GET_DETAIL_PO_PAGE')
    },
    async setTotalEventPage({ commit }, page) {
      await commit('SET_TOTAL_EVENT_PAGE', page)
      await commit('GET_TOTAL_EVENT_PAGE')
    },
    async setTotalEventPerPage({ commit }, page) {
      await commit('SET_TOTAL_EVENT_PERPAGES', page)
      await commit('GET_TOTAL_EVENT_PAGE')
    },
    async setKinerjaKontrakPage({ commit }, page) {
      await commit('SET_KINERJA_KONTRAK_PAGE', page)
      await commit('GET_KINERJA_KONTRAK_PAGE')
    },
    async setKinerjaKontrakPerPage({ commit }, page) {
      await commit('SET_KINERJA_KONTRAK_PERPAGES', page)
      await commit('GET_KINERJA_KONTRAK_PAGE')
    },
    async setUpdateKbli({ commit }, value) {
      await commit('SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-kbli/${value.id}`

        const { data } = await axios({
          method: 'PUT',
          url,
          data: {
            nib: value.nib,
            ss_izin: value.ss_izin,
            dokumen_lainnya: value.dokumen_lainnya,
          },
        })

        if (data && data.status == 'success') {
          store.commit('addEdit/ADD_EDIT_MODAL', {
            name: 'subKbliEdit',
            status: false,
          })
          await commit('GET_INFO_DATA', 'informasi')
          store.commit('SET_NOTIF', 'Update Berhasil')
          await commit('SET_LOADING', true)
        }
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
        await commit('SET_LOADING', true)
      }
    },
    async deleteKbli({ commit }, value) {
      await commit('SET_LOADING', true)
      try {
        const url = `${api}/api/v1/d-vendor-kbli/${value.id}`

        const { data } = await axios({
          method: 'DELETE',
          url,
        })

        if (data && data.status == 'success') {
          store.commit('addEdit/ADD_EDIT_MODAL', {
            name: 'subKbliEdit',
            status: false,
          })
          await commit('GET_INFO_DATA', 'informasi')
          store.commit('SET_NOTIF', data.message)
          await commit('SET_LOADING', true)
        }
      } catch (error) {
        store.commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error')
        )
        await commit('SET_LOADING', true)
      }
    },

    async getAdditionalInfo({ state }) {
      try {
        const url = `${api}/api/v1/md-landing-data?vendor_id=${state.vendorId}&is_active=1&page=1&limit=100000`
        state.isLoading = true

        const { data } = await axios({
          method: 'GET',
          url,
        })

        const getStep = (step, id, form_value, form_sub_value) => {
          let allStep = state[`md_step_${step}`]

          let arrStep = []
          for (let i in allStep) {
            let newStep = allStep[i]
            if (allStep[i].id == id) {
              newStep.form_value = form_value
              newStep.form_sub_value = form_sub_value
            }

            arrStep.push(newStep)
          }
        }

        if (data && data.status == 'success') {
          state.isLoading = false
          let answers = data.data
          state.md_landingpage = answers
          // for (let answer of answers) {
          //   let step = answer.md_landing_step_id
          //   getStep(
          //     step,
          //     answer.md_landing_form_id,
          //     answer.form_value,
          //     answer.form_sub_value
          //   )
          // }
        } else {
          throw new Error('Form not found')
        }
      } catch (err) {
        state.isLoading = false
        if (mixin.methods.$get(err, 'response.status', 0) == 404) {
          // do nothing
        } else {
          store.commit(
            'SET_NOTIF',
            mixin.methods.$get(err, 'response.data.message', 'Error')
          )
        }
      }
    },
  },
}

export default level1
